import * as React from 'react';
import Tab from '@mui/material/Tab';
import OrderSize from './Charts/Operations/OrderSize';
import OrderBehavior from './Charts/Operations/OrderBehavior';
import ChartTabs from '../../Common/ChartTabs';
import CostToServe from './Charts/Operations/CostToServe';

export default function Operations({ height }: { height: number }) {
  return (
    <ChartTabs 
      tabs={[
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Order Size" value="1" />, 
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Order Behavior" value="2" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Cost to Serve" value="3" />]} 
      values={["1", "2", "3"]} 
      ariaLabel="operations tabs" 
      panels={[
        <OrderSize title="Order Size Analysis" height={height} />,
        <OrderBehavior title="Order Behavior" height={height} />,
        <CostToServe title="Cost to Serve" height={height} />
      ]}
    />
  );
}
